import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class FiChipsSelectSearchHelperService {
    private _triggerChipsSelectErrorStateCheck$ = new Subject<void>();
    triggerChipsSelectErrorStateCheck() {
        this._triggerChipsSelectErrorStateCheck$.next();
    }
    onChipsSelectErrorStateCheck$(): Observable<void> {
        return this._triggerChipsSelectErrorStateCheck$.asObservable();
    }
}
